import React, { useEffect,useState} from 'react';
import { useDispatch,useSelector } from "react-redux";

import { fetchReports as fetchReportsService} from 'services/modules/vapt/report';
import { fetchSeverities as fetchSeveritiesService} from 'services/modules/vapt/data';
import { setLoading } from 'stores/modules/idp/authreducer';

import Graph from './Graph';
import ThreatActorGeography from './ThreatActorGeography';
import SignificantThreats from './SignificantThreats';
import CurrentAnalysis from './CurrentAnalysis';
import Loader from 'components/Loader';

import {Card,CardContent} from '@mui/material'
import InfoIcon from '@mui/icons-material/Info';

function DashboardPage() {
  // Redux dispatch
  const dispatch = useDispatch();
  
  // State Variables
  const [progress,setProgress] = useState(false);
  const [report,setReport] = useState("")
  const [value,setValue] = useState("");

  // Redux selectors
  const loading = useSelector((state) => state.auth.loading);
  const selectedCompanyContainer = useSelector((state)=> state.auth.companyData)


  // useEffect hook fetches the ECS severities
  useEffect(() => {
    dispatch(setLoading(true))
    const fetchSeveritiesData = async () =>{
      await dispatch(fetchSeveritiesService({ }));
    };
    const fetchReportsData = async () =>{
      const domain = selectedCompanyContainer.domain;
      let params = { domain: domain };
      let response = await fetchReportsService(params);
      let results = response?.data?.results
      let progress = results?.some(report => report?.reportStatus === "COMPLETED")
      let state = results?.some(report => report?.reportStatus !== "COMPLETED" && report?.reportStatus!=="CANCELLED")
      let report = results?.find(report=>report?.reportStatus !== "CANCELLED" && report?.reportStatus !== "COMPLETED")
      setReport(report)
      setProgress(progress)
      setValue(state);
      if(progress === false)
        dispatch(setLoading(false))

    };
    fetchSeveritiesData();
    fetchReportsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  
  return (
    <div style={{position:'relative'}}>
     {loading && (
        <div className="loader-overlay-dashboard">
          <Loader />
        </div>
      )}

      {!progress ? (
        <div className="dived-card cell-items">
          <Card className="d-block py-3 cap-dashboard-container">
            <CardContent>
              <h5 className="rating-value" style={{fontWeight:'normal'}}>
                <InfoIcon className='cap-info-icon' /> <br />
                {value ? (
                  <>
                  <div>The requested report is currently running</div>
                  <br/>
                  <div>Report Id : <b>{report?.reportId}</b></div>
                  <div>Report Date : {report?.createdAt?.substring(0,10)}</div>
                  </>
                ) : (
                  <>
                  <div>Welcome to the VAPT Dashboard</div>
                  <div>Please request for a new scan</div>
                  </>
                )}
              </h5>
            </CardContent>
          </Card>
        </div>
      ) : (
        <div>
      <div className="row wrapper-row rounded-10" >
        <div className="col-6 col-xs-12 col-sm-12 col-md-12 col-lg-3 rating-flex">
         <Graph chartID="gauge-one"/>
          <div className="vertical-line"></div>
        </div>
        <div className="col-6 col-xs-12 col-sm-12 col-md-12 col-lg-9">
          <CurrentAnalysis/>
        </div>
        <div className="row mt-md col-gutter-md">
        <div className="col-8 col-xs-12 col-sm-12 col-md-12 col-lg-8 pt-0">
        <ThreatActorGeography/>
        </div>
        <div className="class=col-4 col-xs-12 col-sm-12 col-md-12 col-lg-4 pt-0">
          <div className="significant-threat rounded-10">
            <SignificantThreats/>
          </div>
        </div>
        </div> 
      </div>
    </div>
      )}
    </div>
  )
};

export default DashboardPage;